import { belongsTo, type AsyncBelongsTo } from '@ember-data/model';
import type LocationModel from 'garaje/models/location';
import LocationSubscriptionModel from 'garaje/models/location-subscription';

export default class ScopedSubscription extends LocationSubscriptionModel {
  // Override the parent's inverse — Location.locationSubscriptions is
  // hasMany('location-subscription'), not 'scoped-subscription'.
  @belongsTo('location', { async: true, inverse: null })
  declare location: AsyncBelongsTo<LocationModel>;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'scoped-subscription': ScopedSubscription;
  }
}
